import React, { useState, useEffect } from 'react';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

function StatusBadge({ ativo }) {
  if (ativo) {
    return (
      <span style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:11, fontWeight:700,
        color:'#1e7d47', background:'rgba(30,125,71,.1)', border:'1px solid rgba(30,125,71,.25)',
        padding:'3px 10px', borderRadius:999 }}>
        &#9679; Ativo
      </span>
    );
  }
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:5, fontSize:11, fontWeight:700,
      color:'#be2e2e', background:'rgba(190,46,46,.1)', border:'1px solid rgba(190,46,46,.25)',
      padding:'3px 10px', borderRadius:999 }}>
      &#9679; Bloqueado
    </span>
  );
}

export default function AdminUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState('');
  const [atribuindo, setAtribuindo] = useState(null);
  const [alterando, setAlterando] = useState(null);

  const carregar = (b = busca) => {
    setErro('');
    api.get(`/admin/usuarios${b ? `?busca=${encodeURIComponent(b)}` : ''}`)
      .then(({ data }) => setUsuarios(data))
      .catch(err => setErro(err.response?.data?.error || `Erro ao carregar usuários: ${err.message}`));
  };

  useEffect(() => { carregar(); }, []);

  const alterarTipo = async (id, tipo, ativo) => {
    setAlterando(id);
    try {
      await api.patch(`/admin/usuarios/${id}`, { tipo, ativo });
      carregar();
    } finally {
      setAlterando(null);
    }
  };

  const bloquear = async (u) => {
    if (!window.confirm(`Bloquear ${u.nome}? O usuário não conseguirá fazer login.`)) return;
    setAlterando(u.id);
    try {
      await api.patch(`/admin/usuarios/${u.id}`, { tipo: u.tipo, ativo: 0 });
      carregar();
    } finally {
      setAlterando(null);
    }
  };

  const desbloquear = async (u) => {
    setAlterando(u.id);
    try {
      await api.patch(`/admin/usuarios/${u.id}`, { tipo: u.tipo, ativo: 1 });
      carregar();
    } finally {
      setAlterando(null);
    }
  };

  const atribuirPlano = async (id, plano_slug) => {
    if (!plano_slug) return;
    setAtribuindo(id);
    try {
      await api.post(`/admin/usuarios/${id}/assinar`, { plano_slug });
      carregar();
    } catch (err) {
      alert(err.response?.data?.error || 'Erro ao atribuir plano.');
    } finally {
      setAtribuindo(null);
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-title">Usuários</h1>
          <div style={{ display: 'flex', gap: 10 }}>
            <input
              value={busca}
              onChange={e => setBusca(e.target.value)}
              placeholder="Buscar por nome ou e-mail…"
              style={{ padding: '8px 14px', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', fontSize: 13, width: 260 }}
              onKeyDown={e => e.key === 'Enter' && carregar()}
            />
            <button className="btn btn-primary btn-sm" onClick={() => carregar()}>Buscar</button>
          </div>
        </div>

        {erro && (
          <div className="alert alert-danger" style={{ marginBottom: 16 }}>
            {erro}
          </div>
        )}

        <div className="tabela-scroll">
          <table className="tabela">
            <thead>
              <tr>
                <th>Nome</th>
                <th>E-mail / WhatsApp</th>
                <th>Tipo</th>
                <th>Status</th>
                <th>Cadastro</th>
                <th>Alterar tipo</th>
                <th>Atribuir plano</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u.id} style={{ opacity: alterando === u.id ? 0.6 : 1, transition: '.2s' }}>
                  <td style={{ fontWeight: 700 }}>{u.nome}</td>
                  <td style={{ fontSize: 12 }}>
                    <div>{u.email}</div>
                    {u.whatsapp && <div style={{ color: 'var(--ink-muted)', marginTop: 2 }}>{u.whatsapp}</div>}
                  </td>
                  <td><span className={`badge badge-${u.tipo}`}>{u.tipo}</span></td>
                  <td><StatusBadge ativo={!!u.ativo} /></td>
                  <td style={{ fontSize: 12, color: 'var(--ink-muted)' }}>
                    {new Date(u.created_at).toLocaleDateString('pt-BR')}
                  </td>
                  <td>
                    <select
                      value={u.tipo}
                      onChange={e => alterarTipo(u.id, e.target.value, u.ativo ?? 1)}
                      disabled={alterando === u.id}
                      style={{ padding: '5px 10px', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', fontSize: 12, background: '#fff' }}
                    >
                      <option value="visitante">Visitante</option>
                      <option value="basico">Básico</option>
                      <option value="premium">Premium</option>
                      <option value="admin">Admin</option>
                    </select>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button
                        className="btn btn-sm btn-outline"
                        style={{ fontSize: 11, padding: '4px 10px' }}
                        disabled={atribuindo === u.id}
                        onClick={() => atribuirPlano(u.id, 'basico')}
                      >
                        Básico
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        style={{ fontSize: 11, padding: '4px 10px' }}
                        disabled={atribuindo === u.id}
                        onClick={() => atribuirPlano(u.id, 'premium')}
                      >
                        Premium
                      </button>
                    </div>
                  </td>
                  <td>
                    {u.ativo
                      ? (
                        <button
                          className="btn btn-sm"
                          style={{ fontSize: 11, padding: '4px 12px', background: 'rgba(190,46,46,.1)', color: '#be2e2e', border: '1px solid rgba(190,46,46,.25)', borderRadius: 6 }}
                          disabled={alterando === u.id}
                          onClick={() => bloquear(u)}
                        >
                          Bloquear
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm btn-success"
                          style={{ fontSize: 11, padding: '4px 12px' }}
                          disabled={alterando === u.id}
                          onClick={() => desbloquear(u)}
                        >
                          Desbloquear
                        </button>
                      )
                    }
                  </td>
                </tr>
              ))}
              {usuarios.length === 0 && !erro && (
                <tr>
                  <td colSpan={9} style={{ textAlign: 'center', color: 'var(--ink-muted)', padding: 36 }}>
                    Nenhum usuário encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <p style={{ marginTop: 16, fontSize: 12, color: 'var(--ink-muted)', lineHeight: 1.6 }}>
          <strong style={{ color: 'var(--ink)' }}>Bloqueio:</strong> usuários bloqueados não conseguem fazer login, acessar anúncios, ver contatos de vendedores ou usar a área Premium.
        </p>
      </div>
    </div>
  );
}
